/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: forms.js
 */
$.namespace("SCS.portal.forms");

/**
 * Clear errors
 */
// used by Tc.Module.SmsEService
SCS.portal.forms.clearErrors = function() {
	$(".scs-form")
		.find(".field.error")
			.find(".error, .fullLengthError")
				.hide()
				.end()
			.removeClass("error")
			.end()
		.find(".headingError").closest(".field").hide();
};

/**
 * Make field and button fit into the full width of the form
 */
jQuery(function() {
	jQuery('.teaserform form.scs-form, .supportstrip form.scs-form').each(function() {
		var form = jQuery(this);
		var input = form.find(':input:not(:button, :submit)');
		var submit = form.find(':button, :submit');
		if(submit.parent()[0] !== form[0]) {
			submit = submit.parent();
		}
		var full = form.width();
		var space =
			parseInt(input.css('marginLeft'), 10) +
			parseInt(input.css('marginRight'), 10) +
			parseInt(input.css('paddingLeft'), 10) +
			parseInt(input.css('paddingRight'), 10) +
			parseInt(input.css('borderLeftWidth'), 10) +
			parseInt(input.css('borderRightWidth'), 10) +
			parseInt(submit.css('marginLeft'), 10) +
			parseInt(submit.css('marginRight'), 10) +
			parseInt(submit.css('paddingLeft'), 10) +
			parseInt(submit.css('paddingRight'), 10) +
			parseInt(submit.css('borderLeftWidth'), 10) +
			parseInt(submit.css('borderRightWidth'), 10);
		var submitWidth = submit.width();
		var tolerance = 6;
		input.css('width', (full - submitWidth - space - tolerance)+'px');
	});
});

/**
 * Handle DropDown Fields
 */
(function () {
	$(document).on('beforeInit.sSelect', function (e) {
		$(e.target).data('autoPosition', false);
	});
	$(document).on('afterInit.sSelect', function (e) {
		var list = $(e.target).parent().find('ul.newList');
		list.css({ 'position':'', 'top':'', 'left':'' }).wrap('<div class="newListWrapper" />');
		list.css('min-width', (list.closest('.newListSelected').outerWidth() - (list.outerWidth() - list.width())) + 'px');
	});
})();


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/forms.js
// module id = 80
// module chunks = 0